import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/site/SmoothScroll";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import WhatsAppWidget from "@/components/site/WhatsAppWidget";
import { trackPageView } from "@/lib/analytics";
import { captureAttribution } from "@/lib/attribution";
import Home from "@/pages/Home";
import Industries from "@/pages/Industries";
import Capabilities from "@/pages/Capabilities";
import WhatWeSource from "@/pages/WhatWeSource";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import SourcingRequest from "@/pages/SourcingRequest";
import Corporate from "@/pages/Corporate";
import Partners from "@/pages/Partners";
import Certifications from "@/pages/Certifications";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const RouteEffects = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Capture attribution once (first-touch) — also re-check UTM every route in case of client-side params
    captureAttribution();
    window.scrollTo({ top: 0, behavior: "instant" });
    // Do not track admin routes
    if (!pathname.startsWith("/admin")) {
      trackPageView();
    }
  }, [pathname]);
  return null;
};

// Hide site chrome (Header, Footer, WhatsApp) on admin routes for a focused workspace
function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Header />}
      <main data-testid="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/capabilities" element={<Capabilities />} />
          <Route path="/what-we-source" element={<WhatWeSource />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/about" element={<About />} />
          <Route path="/sourcing-request" element={<SourcingRequest />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/corporate" element={<Corporate />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/certifications" element={<Certifications />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppWidget />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App bg-nx-bg text-nx-ink min-h-screen nx-grain" data-testid="app-root">
        <BrowserRouter>
          <SmoothScroll>
            <RouteEffects />
            <Shell />
          </SmoothScroll>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="light"
          toastOptions={{
            style: {
              background: "#1B3D6E",
              color: "#EDEEEA",
              border: "1px solid #1B3D6E",
              borderRadius: 0,
              fontFamily: "IBM Plex Sans, sans-serif",
            },
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
